import { fork, all } from 'redux-saga/effects'
import watcherV2 from 'sagas/V2'
import watcherV3 from 'sagas/V3'
import uiState from 'sagas/uiState'

export default function* watch() {
  yield all([fork(watcherV2), fork(uiState), fork(watcherV3)])
}
